import * as React from 'react';
import { Button, Typography, Grid2 as Grid } from '@mui/material';
import OfferItem from '../elements/offer-item';
import { InfoStrip } from '../elements/info-strip';
import { ProblemsSolutions } from '../../types/blocks/problems-solutions';
import { DynamicText } from '../elements/dynamic-text';
import { CallToActionButton } from '../elements/call-to-action-button';

interface SectionViblyProblemsSolutionsProps {
  element: ProblemsSolutions;
}

export const SectionViblyProblemsSolutions: React.FC<SectionViblyProblemsSolutionsProps> = ({
  element,
}) => (
  <div className="bg-[#15151A]">
    <div className="px-4 py-16 sm:py-24 md:py-32 space-y-12">
      <div className="max-w-[500px] mx-auto">
        <Typography variant="h1" component="h2" className="text-center">
          {element.problemsTitle}
        </Typography>
      </div>

      <div className="space-y-2 md:space-y-4 max-w-[700px] mx-auto">
        {element.problems?.map((el) => <InfoStrip key={el.title} text={el.title} />)}
      </div>
    </div>

    <div
      className="py-16 sm:py-24 md:py-32 px-4 bg-cover bg-top"
      style={{
        backgroundImage: "url('/assets/images/homepage/bg-photo.png')",
      }}
    >
      <div className="max-w-[1000px] mx-auto space-y-2">
        <div className="space-y-12 md:space-y-16 px-6 py-10 sm:p-14 md:p-20 bg-paper rounded-3xl">
          <div className="max-w-[680px] mx-auto">
            <span className="flex flex-wrap justify-center gap-x-2">
              <DynamicText text={element.solutionsTitle} />
            </span>
          </div>
          <div className="space-y-8 md:space-y-16">
            <Grid container spacing={{ xs: 8, lg: 13 }}>
              {element.solutions.length > 0 &&
                element.solutions.map((item) => (
                  <Grid size={{ md: 6 }} key={item.title}>
                    <OfferItem title={item.title} description={item.description} image={false} />
                  </Grid>
                ))}
            </Grid>
          </div>
        </div>
        <div className="rounded-3xl bg-paper p-8 md:p-14 text-center overflow-hidden relative">
          <div className="space-y-4 sm:space-y-8 relative z-10">
            <Typography variant="h1" component="h3">
              {element.callToAction.description}
            </Typography>
            <CallToActionButton button={element.callToAction} />
          </div>
          <img
            src="/assets/images/homepage/three-vertical-semicircle.svg"
            className="absolute top-0 right-0 h-full"
          />
        </div>
      </div>
    </div>
  </div>
);
